<div class="row">
  <div class="col-12">
    <h3 class="text-center">Not Found</h3>
  </div>
</div>
